/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Quick Schedule Stepper styles
 *
 * @file QuickScheduleStepperStyles.js
 * @author Anuja Gaikwad
 * @since 2.0.3
 */

import { styled } from '@mui/material/styles';
import mixins from '../../../assets/styles/mixins.scss';
import { createScopedClasses, createScopedStyles } from '../../../assets/styles/createScopedStyles';

const QuickScheduleStepperStyles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',

    [mixins['md-sm-maxwidth']]: {
      justifyContent: 'flex-end',
      padding: 0
    },

    [mixins['ml-max']]: {
      padding: 0
    }
  },
  stepButton: {
    width: 32,
    height: 32,
    minWidth: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px',
    fontFamily: mixins.fontFamilyPlusSans,
    padding: 0,
    cursor: 'pointer',
    boxSizing: 'border-box'
  },
  stepActive: {
    backgroundColor: '#C1BFFF',
    color: mixins.amethyst,
    border: 'none'
  },
  stepInactive: {
    border: '1px solid rgba(13, 0, 77, 0.35)',
    color: mixins.color_text_primary,
    backgroundColor: mixins.chalkWhiteFont
  },
  stepCompleted: {
    backgroundColor: mixins.amethyst,
    color: mixins.chalkWhiteFont,
    border: 'none'
  },
  stepDisabled: {
    cursor: 'not-allowed',
    opacity: 0.45
  },
  tickIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
    '& svg': {
      width: 16,
      height: 16
    }
  },
  connector: {
    width: 24,
    height: 1,
    backgroundColor: 'rgba(81, 46, 171, 0.15)'
  }
});

export const classes = createScopedClasses('aet-quick-schedule-stepper', QuickScheduleStepperStyles());

export const scopedStyles = createScopedStyles(QuickScheduleStepperStyles(), classes);

export const QuickScheduleStepperStylesRoot = styled('nav')(scopedStyles);

export default QuickScheduleStepperStyles;
